import React from "react";
import moment from "moment";
import { Modal, DatePicker, Select, Input, Tabs, message } from "antd";
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import Fetch from "../../../../common/Fetch";

const { MonthPicker } = DatePicker;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

const tabs = [{
    tab:'已确认收入未开票',
    key:'cl',
},{
    tab:'已开票未回款',
    key:'empty',
}]

class UpdateARplan extends React.Component {
    state = {
        visible: false,
        params: {},
        activeKey: 'cl',
        paymentAmountList: [],
    }

    show = (record = {}) => {
        const { estimatedCompletionTimeStr, cl, empty } = record;
        this.setState({
            visible: true,
            params: {
                ...record,
                estimatedCompletionTimeStr: estimatedCompletionTimeStr ? moment(estimatedCompletionTimeStr).format('YYYY-MM') : '',
                cl: cl ? cl : {},
                empty: empty ? empty : {},
            },
        }, () => {
            this.queryStopBreathingCode();
        });
    }

    queryStopBreathingCode = () => {
        const { activeKey } = this.state;
        Fetch.post(API_URL.contract.queryStopBreathingCode, { 
            type: activeKey == 'cl' ? 'paymentAmount' : 'receivingAmount' 
        }).then(res => {
            const { data = [] } = res;
            this.setState({ paymentAmountList: data });
        }).catch(error => {
            console.error(error);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { params, activeKey } = this.state;
        const { investigationId, investigationJdeContractCode } = params;
        const { actionPlan, estimatedCompletionTimeStr, nextNodeManager } = (params[activeKey] || {});
        if (!actionPlan) {
            return message.warning('请输入行动计划')
        }
        if (!estimatedCompletionTimeStr) {
            return message.warning('请选择预计完成时间')
        }
        if (!nextNodeManager) {
            return message.warning('请选择下一节点负责人')
        }
        const options = {
            method: 'POST',
            url: API_URL.investigation.saveAccountsReceivablePlan,
            data: {
                investigationId,
                jdeCode: investigationJdeContractCode,
                actionPlan,
                estimatedCompletionTimeStr: moment(estimatedCompletionTimeStr).format('YYYY-MM'),
                nextNodeManager,
                planType: activeKey == 'cl' ? 'REQUEST_FUNDS' : 'PAYMENT_COLLECTION',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params, activeKey } = this.state; 
        params[activeKey][key] = value;
        this.setState({ params });
    }

    handleTabClick = (key) => {
        this.setState({
            activeKey: key,
        },() => {
            this.queryStopBreathingCode();
        })
    }

    render() {
        const { visible, params, activeKey, paymentAmountList } = this.state;
        const { actionPlan, estimatedCompletionTimeStr, nextNodeManager } = params[activeKey] || {};
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const paymentAmountOptions = paymentAmountList.map(el => <Option value={el.code}>{el.code}</Option>)
        return (
            <Modal
                title="更新AR计划"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                width="560px"
                maskClosable={false}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <ul className="modal-list">
                    <li className="modal-item">
                            <div className="item-left">{asterisk}行动计划:</div>
                            <div className="item-right">
                                <Input  
                                    placeholder="请输入"
                                    style={{ width: 220 }}
                                    value={actionPlan}
                                    onChange={e => this.handleChange(e.target.value, 'actionPlan')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}预计完成时间:</div>
                            <div className="item-right">
                                <MonthPicker
                                    allowClear={false}
                                    placeholder="请选择"
                                    style={{ width: 220 }}
                                    value={estimatedCompletionTimeStr ? moment(estimatedCompletionTimeStr) : null}
                                    onChange={(date, dateString) => this.handleChange(dateString, 'estimatedCompletionTimeStr')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">{asterisk}下一节点负责人:</div>
                            <div className="item-right">
                                <Select
                                    allowClear
                                    placeholder="请选择"
                                    style={{ width: 220 }}
                                    value={nextNodeManager}
                                    onChange={value => this.handleChange(value, 'nextNodeManager')}
                                >
                                    {paymentAmountOptions}
                                </Select>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default UpdateARplan;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/UpdateARplan.js